import { useMutation, UseMutationConfig } from '@libs/use';
import { OrderItem } from '@libs/api-reference';

import * as API from '../requests';

function deleteOrderFactory(order: OrderItem) {
  return {
    algorithmId: order?.orderId,
    action: 2, // Cancel
  };
}

type UseDeleteOrderQueryConfigs = {
  onSuccess?: UseMutationConfig<any>['onSuccess'];
  onReject?: UseMutationConfig<any>['onReject'];
};

export default function useDeleteOfflineOrderQuery({
  onReject,
  onSuccess,
}: UseDeleteOrderQueryConfigs = {}) {
  const {
    execute: deleteOfflineOrder,
    isPending: isLoadingDeleteOfflineOrder,
    isError: isErrorDeleteOfflineOrder,
    ...query
  } = useMutation(
    ({ selectedOrder: order }: { selectedOrder: OrderItem }) =>
      API.deleteOfflineOrder(deleteOrderFactory(order)),
    {
      onReject,
      onSuccess,
    }
  );

  return {
    deleteOfflineOrder,
    isLoadingDeleteOfflineOrder,
    isErrorDeleteOfflineOrder,
    ...query,
  };
}
